import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';

const pinia = createPinia();

export default function init() {
  const element = document.getElementById('productFilter');

  if (!element) {
    return;
  }

  let mountEl = document.getElementById('productFilter-vue-root');

  if (!mountEl) {
    mountEl = document.createElement('div');
    mountEl.id = 'productFilter-vue-root';
    element.insertAdjacentElement('afterend', mountEl);
  }

  const app = createApp(App, { ...element.dataset });

  app.use(pinia);
  app.mount(mountEl);
}
